// @ts-expect-error: implicitly has an 'any' type
import buildFormatLongFn from 'date-fns/locale/_lib/buildFormatLongFn';

const dateFormats = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'd/MM/yyyy',
};

const timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm',
};

const dateTimeFormats = {
  full: "{{date}} 'markay saacadu tahay:' {{time}}",
  long: "{{date}} 'markay saacadu tahay:' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}',
};

export const formatLong: Locale['formatLong'] = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full',
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full',
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full',
  }),
};
